"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var basket_exports = {};
__export(basket_exports, {
  Basket: () => Basket
});
module.exports = __toCommonJS(basket_exports);
var Basket;
((Basket2) => {
  let Add;
  ((Add2) => {
    Add2.path = "basket/add";
  })(Add = Basket2.Add || (Basket2.Add = {}));
  let ChangeRequest;
  ((ChangeRequest2) => {
    ChangeRequest2.path = "basket/changeRequest";
  })(ChangeRequest = Basket2.ChangeRequest || (Basket2.ChangeRequest = {}));
  let Qty;
  ((Qty2) => {
    Qty2.path = "basket/qty";
  })(Qty = Basket2.Qty || (Basket2.Qty = {}));
  let Remove;
  ((Remove2) => {
    Remove2.path = "basket/remove";
  })(Remove = Basket2.Remove || (Basket2.Remove = {}));
  let Flush;
  ((Flush2) => {
    Flush2.path = "basket/flush";
  })(Flush = Basket2.Flush || (Basket2.Flush = {}));
})(Basket || (Basket = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Basket
});
